import { render, staticRenderFns } from "./BodyMap.vue?vue&type=template&id=4e29dc6c&scoped=true&"
import script from "./BodyMap.vue?vue&type=script&lang=js&"
export * from "./BodyMap.vue?vue&type=script&lang=js&"
import style0 from "@/assets/sass/components/views/dashboard/members/id/body-map.scss?vue&type=style&index=0&id=4e29dc6c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e29dc6c",
  null
  
)

export default component.exports